(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    const modal = document.getElementById('blckapex-notify-modal');
    const openButtons = document.querySelectorAll('[data-blckapex-open]');
    const closeButtons = document.querySelectorAll('[data-blckapex-close]');

    if (!modal) return;

    function openModal() {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    }

    function closeModal() {
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openModal);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    // Mark this as a genuine, just-now submission so the reopen-after-redirect
    // check below can't be triggered by a stale/bookmarked ?customer_posted=true URL.
    const notifyForm = document.getElementById('blckapex_notify_form');
    if (notifyForm) {
      notifyForm.addEventListener('submit', function () {
        try {
          sessionStorage.setItem('blckapexNotifySubmitted', '1');
        } catch (e) {}
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.open) {
        closeModal();
      }
    });

    const countdowns = document.querySelectorAll('.blckapex-countdown');

    if (countdowns.length) {
      function updateCountdown() {
        countdowns.forEach(function (countdown) {
          const dropDate = new Date(countdown.dataset.dropDate).getTime();
          const daysEl = countdown.querySelector('[data-days]');
          const hoursEl = countdown.querySelector('[data-hours]');
          const minutesEl = countdown.querySelector('[data-minutes]');
          const secondsEl = countdown.querySelector('[data-seconds]');

          const now = new Date().getTime();
          const distance = dropDate - now;

          if (distance <= 0) {
            daysEl.textContent = '00';
            hoursEl.textContent = '00';
            minutesEl.textContent = '00';
            secondsEl.textContent = '00';
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((distance / (1000 * 60)) % 60);
          const seconds = Math.floor((distance / 1000) % 60);

          daysEl.textContent = String(days).padStart(2, '0');
          hoursEl.textContent = String(hours).padStart(2, '0');
          minutesEl.textContent = String(minutes).padStart(2, '0');
          secondsEl.textContent = String(seconds).padStart(2, '0');
        });
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    let justSubmitted = false;
    try {
      justSubmitted = sessionStorage.getItem('blckapexNotifySubmitted') === '1';
    } catch (e) {}

    if (justSubmitted && window.location.search.includes('customer_posted=true')) {
      openModal();
      try {
        sessionStorage.removeItem('blckapexNotifySubmitted');
      } catch (e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
